(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-faq"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;
class FaqSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.$answers = this.queryAll('[data-pxu-faq-answer]');

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateItemHeights();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.events.register(window, 'resize', debounce(
      () => this.updateItemHeights(), 200)
    );
  }

  updateItemHeights() {
    this.$answers.forEach(($answer) => {
      const openHeight = $answer.scrollHeight;
      $answer.style.setProperty('--open-height', `${openHeight}px`);
    });
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = true;
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = false;
  }
}

document.querySelectorAll(`[data-pxu-faq]`).forEach(($section) => {
  Section.init($section, FaqSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.FaqSection = FaqSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();
})();
